<mat-card>
  <mat-card-content>
    <form [formGroup]="videoConfig" (ngSubmit)="onSubmit()">
      <h2>Create Video url Configuration</h2>
      <mat-form-field [style.display]="'none'" class="full-width-input">
        <input matInput placeholder="Id" formControlName="id">
      </mat-form-field>
      <mat-form-field [style.display]="'none'" class="full-width-input">
        <input matInput placeholder="CreatedForCompany" formControlName="createdForCompany">
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Config Name" formControlName="name" required>
        <mat-error>
          Please provide a valid Video config name
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Config Description" formControlName="description" required>
        <mat-error>
          Please provide a valid description
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Config Url(YouTube url)" formControlName="url" required>
        <mat-error>
          Please provide a valid YouTube Url
        </mat-error>
      </mat-form-field>
      <button mat-raised-button color="primary">Create</button>
    </form>
  </mat-card-content>
</mat-card>


<div class="col-md-12">
	<table class="table table-responsive table-hover">
		<tr>
			<th>User Id</th>
			<th>Name</th>
			<th>Description</th>
			<th>Edit</th>
			<th>Delete</th>
		</tr>
		<tr *ngFor="let item of records">
			<td>{{item.name}}</td>
			<td>{{item.description}}</td>
			<td>{{item.url}}</td>
			<td><span *ngIf="this.appData.availablePrivileges.value.UPDATE_VIDEO"><a (click)="updateVideoConfig(item.id)">
				<button mat-button>
					<mat-icon>edit</mat-icon>
				</button>
				</a></span> &nbsp;
			</td>
			<td><span *ngIf="this.appData.availablePrivileges.value.DELETE_VIDEO">
				<button mat-button (click)="deleteVideoConfig(item.id)">
					<mat-icon>delete_forever</mat-icon> 
				</button>
				<a [routerLink]="['/individual-delete',{'id':item.id}]">
				<button >
					<mat-icon>delete_forever</mat-icon>
				</button>
				</a>
				</span>&nbsp;
			</td>
		</tr>
	</table>
</div>